"use client";

import { startTransition, type MouseEvent } from 'react';
import { IoBagHandleOutline } from 'react-icons/io5';
import { useCart } from '../context/CartContext';
import QuantityStepper from './QuantityStepper';
import { Product } from '../types';

type ProductCardActionsProps = {
  product: Product;
};

const ProductCardActions = ({ product }: ProductCardActionsProps) => {
  const { addToCart, updateQuantity, getItemQuantity } = useCart();
  const quantityInCart = getItemQuantity(product.id);

  const handleAddToCartClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    startTransition(() => {
      addToCart(product);
    });
  };

  return (
    <>
      {quantityInCart === 0 ? (
        <button
          onClick={handleAddToCartClick}
          className="group/btn ui-button flex w-full items-center justify-center gap-2 py-2.5"
        >
          <IoBagHandleOutline size={18} className="transition-transform group-hover/btn:-translate-y-0.5" />
          Add to Cart
        </button>
      ) : (
        <div className="flex w-full justify-center">
          <QuantityStepper
            quantity={quantityInCart}
            onIncrease={(e?: any) => {
              e?.preventDefault();
              startTransition(() => {
                updateQuantity(product.id, quantityInCart + 1);
              });
            }}
            onDecrease={(e?: any) => {
              e?.preventDefault();
              startTransition(() => {
                updateQuantity(product.id, quantityInCart - 1);
              });
            }}
          />
        </div>
      )}
    </>
  );
};

export default ProductCardActions;
